import * as React from 'react';
import {
	chakra,
	ImageProps,
	forwardRef,
} from '@chakra-ui/react';
import scanNotificationIcon from 'Assets/svg/scanIcon.svg';

export const ScanIcon = forwardRef<ImageProps, 'img'>((props, ref) => {
	return <chakra.img src={scanNotificationIcon} ref={ref} {...props} />;
}); 